import {detectTextDirection} from "../../utils/detectTextDirection";
import {formatTextSigns} from "../../utils/formatTextSigns";
import {formatTimeNoDate} from "../../utils/friendlyDate";
import {StatusView} from "../messages/StatusView";
import React from "react";
import {CONVERSATION_VIEWS} from "./Conversations";
import {ConversationMessage} from "../../types/ConversationMessage";
import {ConversationRow, Segment, SegmentMessage} from "../../types/ConversationProps";

interface SegmentMessageBubbleProps {
    message: SegmentMessage;
    onDemoMessageButtonClick: () => void;
}

const SegmentMessageBubble = ({ message, onDemoMessageButtonClick }: SegmentMessageBubbleProps) => {
    const isReadStatus = message.totalMessagesRead === message.totalMessagesSent;
    const isDeliveredStatus = message.totalMessagesDelivered === message.totalMessagesSent;
    return (
        <div className='message-bubble-container shop'>
            <div className="message-bubble">
                {message.imageUrl ? <img alt="Message Image" src={message.imageUrl} /> : null}
                <span className={detectTextDirection(message.content)}>{formatTextSigns(message.content)}</span>
                <div className="message-time-and-status">
                    <div className="message-time">{formatTimeNoDate(new Date(message.createdAt))}</div>
                    <div className="message-status"><StatusView value={isReadStatus ? 'READ' : isDeliveredStatus ? 'DELIVERED' : 'UNKNOWN'} isInBubble={true} /></div>
                </div>
            </div>
        </div>
    );
}

export default SegmentMessageBubble;